<template>
  <div>
    <ministry-breadcrumbs :mainTitle="mainTitle" :breadcrumbs="breadcrumbs" />
    <b-card>
      <div style="position: relative">
        <b-row class="justify-content-between align-items-center">
          <b-col class="d-flex align-items-center">
            <h3>معاملات التوسّط</h3>
          </b-col>
          <b-col cols="3">
            <form-autocomplete
              :getOptionLabel="(x) => x.name_ar"
              :reduce="(x) => x.id"
              v-model="searchKey.ngo_id"
              ep="v2/guest/filter-name"
              id="ngos"
              filterKey="name"
              placeholder="البحث بحسب اسم المنظمة"
            />
          </b-col>
          <b-col md="3">
            <search-input
              placeholder="البحث بحسب الجهة"
              v-model="searchKey.destination"
            />
          </b-col>
        </b-row>
        <hr />
        <data-table
          id="ngos-table"
          :ep.sync="ep"
          :fields="fields"
          ref="requestesTable"
        >
          <template #cell(status)="{ value }">
            <b-badge
              :variant="
                value === 'active'
                  ? value === 'active'
                    ? 'light-success'
                    : 'light-secondary'
                  : 'light-danger'
              "
            >
              <span v-if="value === 'active'">فعال</span>
              <span v-else-if="value === 'frozen'">مجمد</span>
              <span v-else>غير فعال</span>
            </b-badge>
          </template>

          <template #cell(created_at)="{ value }">
            <span
              >{{ value ? $moment(value).format("HH:mm DD-MM-YYYY") : "" }}
            </span>
          </template>
          <template #cell(actions)="{ item }">
            <b-dropdown
              variant="link"
              no-caret
              :left="$store.state.appConfig.isRTL"
            >
              <template #button-content>
                <feather-icon
                  icon="MoreVerticalIcon"
                  size="16"
                  class="align-middle text-body"
                />
              </template>
              <b-dropdown-item
                v-can="{ slug: $route.meta.slug, action: 'S' }"
                target="_blank"
                @click="
                  $router.push({ name: 'file-view', query: { ep: item.path } })
                "
              >
                <feather-icon icon="EyeIcon" />
                <span class="align-middle ml-50">عرض الطلب</span>
              </b-dropdown-item>
              <b-dropdown-item
                v-can="{ slug: $route.meta.slug, action: 'S' }"
                @click="
                  $router.push({
                    name: 'settings-mediation-requestes-show',
                    params: { id: item.id },
                  })
                "
              >
                <feather-icon icon="ListIcon" />
                <span class="align-middle ml-50">سجلات مسح</span>
              </b-dropdown-item>
              <b-dropdown-item
                v-can="{ slug: $route.meta.slug, action: 'U' }"
                @click="onFreezeClicked(item.id)"
                :disabled="item.status === 'frozen'"
              >
                <feather-icon icon="XIcon" />
                <span class="align-middle ml-50">تجميد الطلب</span>
              </b-dropdown-item>
            </b-dropdown>
          </template>
        </data-table>
      </div>
    </b-card>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BCard,
  BButton,
  BDropdown,
  BDropdownItem,
  BBadge,
} from "bootstrap-vue";
import MinistryBreadcrumbs from "@/modules/ministry/components/MinistryBreadcrumbs.vue";
import { mapActions, mapGetters } from "vuex";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import DataTable from "@/components/data-table";
import debounce from "lodash.debounce";
import SearchInput from "@/components/SearchInput.vue";
import formAutocomplete from "@/components/form-autocomplete";
export default {
  components: {
    BBadge,
    formAutocomplete,
    SearchInput,
    BRow,
    BCol,
    BCard,
    BButton,
    BDropdown,
    BDropdownItem,
    MinistryBreadcrumbs,
    DataTable,
  },

  data() {
    return {
      mainTitle: "إدارة المعاملات",

      type: "ADD",
      searchKey: {},
      ep: "v2/ministry/files-qrs/index",

      fields: [
        { label: "المعرف", key: "id" },
        { label: "المستخدم", key: "name_ar" },
        { label: "الجهة", key: "destination" },
        { label: "الحالة", key: "status" },
        { label: "تاريخ الإنشاء", key: "created_at" },
        { label: "المنظمة", key: "ngo.name_ar" },
        { label: " ", key: "actions" },
      ],
      breadcrumbs: [
        {
          // old
          // text: "الإعدادات",
          //new 
          
          text: "إدارة المنظمات",
          to: "/ministry/ngos-communication",
        },
        {
          text: "معاملات التوسّط",
          active: true,
        },
      ],
    };
  },

  watch: {
    searchKey: {
      deep: true,
      handler: debounce(function (value) {
        this.$refs.requestesTable.setQueryParams(this.searchKey);
        this.$refs.requestesTable.refreshTable();
      }, 300),
    },
  },
  methods: {
    ...mapActions("Ministry/Settings/MediationRequestes", ["freezeRequest"]),

    async onFreezeClicked(id) {
      this.$bvModal
        .msgBoxConfirm("هل أنت متأكد من تجميد الطلب ؟", {
          title: "تأكيد تجميد طلب توسّط",
          size: "sm",
          okVariant: "danger",
          okTitle: "تأكيد",
          cancelTitle: "إلغاء",
          cancelVariant: "outline-secondary",
          hideHeaderClose: false,
          centered: true,
        })
        .then(async (value) => {
          if (value) {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "جاري التجميد ...",
                icon: "LoadingIcon",
                variant: "info",
              },
            });
            await this.freezeRequest(id);
            this.$refs.requestesTable.refreshTable();
          }
        });
    },
  },
};
</script>
